var exports = {
  "vK": "banner__Q467Ef",
  "u7": "logolink__cl6ut3",
  "Qg": "visuallyHidden__qrJvzL",
  "pq": "info__23t-kj",
  "yF": "divider__XZJxxs",
  "DD": "title__p98J3a",
  "nf": "link__ZS0QeK",
  "W9": "liveDot__0F1TYK",
  "Fm": "liveHighlight__ADXGon",
  "me": "separator__SgMo6e",
  "qW": "countdown__eFq5PD",
  "YE": "closeWrapper__VmRF-Q",
  "b": "closeButton__2B-u4Q",
  "XT": "dark__IEe7Gi",
};

module.exports = exports;
